/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import Header from "../components/header/Header";
import DocumentCard from "../components/documentCard/DocumentCard";
import TopBar from "../components/topBar/TopBar";
import {
	correctPublicationsAtom,
	projectTitleAtom,
} from "../utils/hooks/LoadingHook";
import { atom, useAtom } from "jotai";
import { getTopThreeGraphData } from "../utils/services/topThreeDocsService";
import TopThreeGraph from "../components/analytics/TopThreeDocs";
import TooltipsTemplate from "../utils/tooltips/TooltipsTemplate";
import { setBenchmarkCriteriaAverages } from "../utils/services/benchmarkServices";
import { ColorVariantEnum, HeadingSizeEnum, Text } from "@foleon/atomic";

export const PROJECT_ID = Number(localStorage.getItem("project_id"));
export const benchmarkCriteriaAtom = atom<any>(undefined);

export const Dashboard = () => {
	const [correctPublications] = useAtom(correctPublicationsAtom);
	const [projectTitle] = useAtom(projectTitleAtom);
	const [topThreeDocs, setTopThreeDocs] = useState<any>({});
	const [isTopThreeDocsLoaded, setIsTopThreeLoaded] = useState(false);
	const [benchmarkCriteria, setBenchmarkCriteria] = useAtom(benchmarkCriteriaAtom);
	const [isBenchmarkCriteriaLoaded, setBenchmarkCriteriaLoaded] = useState(false);
	const tooltipContext =
		`This graph displays your three best-performing Foleon docs based on their amount of unique views.
		The Y-axis shows the amount of unique views.
		The X-axis shows the title of the Foleon doc.`;

	useEffect(() => {
		if (correctPublications) {
			setTopThreeDocs(
				getTopThreeGraphData(correctPublications, setIsTopThreeLoaded)
			);
			setBenchmarkCriteria(setBenchmarkCriteriaAverages(correctPublications));
		}
	}, []);

	useEffect(() => {
		if (benchmarkCriteria)
			setBenchmarkCriteriaLoaded(true);
	}, [benchmarkCriteria]);

	// only to print benchmark criteria
	useEffect(() => {
		if (isBenchmarkCriteriaLoaded) {
			console.log(benchmarkCriteria);
		}
	}, [isBenchmarkCriteriaLoaded]);

	return (
		<>
			<Flex direction="column"
				  w="100%"
				  gap="32px"
				  alignItems="center"
			>
				<TopBar />
				<Header domain="foleon.com" projectName={projectTitle} />
				<Flex
					direction="row"
					justifyContent="center"
					flexWrap="wrap"
					mt="32px"
					gap="16px"
				>
					{correctPublications.map((pub) => {
						return (
							<DocumentCard
								publicationName={pub.name}
								publicationId={pub.id}
								publicationTotalPages={pub.data.totalPages}
								key={pub.id}
							/>
						);
					})}
				</Flex>

				{isTopThreeDocsLoaded && (
					<Flex direction="column"
						  borderRadius=".5%"
						  alignItems="center"
						  marginTop="1%"
						  h="75%"
						  w="75%"
						  shadow="lg"
					>
						<Flex marginTop="1%"
							  bgGradient="linear-gradient(153deg, rgba(34,54,89,1) 0%,
							  rgba(0,177,255,1) 35%,
							  rgba(0,161,255,1) 64%)"
							  m="0"
							  w="100%"
							  padding="1% 0"
							  borderRadius=".5%"
							  direction="column"
							  alignItems="center"
						>
							<Text.Heading
								size={HeadingSizeEnum.MEDIUM}
								colorVariant={ColorVariantEnum.WHITE}
								margin="0"
							>
								Top Three Docs
							</Text.Heading>
						</Flex>
						<Box marginTop=".5%">
							<TooltipsTemplate text={tooltipContext}></TooltipsTemplate>
						</Box>

						<Box h="100%" w="100%">
							<TopThreeGraph
								labels={topThreeDocs.labels}
								datasets={topThreeDocs.datasets}
							/>
						</Box>
					</Flex>
				)}
			</Flex>
		</>
	);
};

export default Dashboard;
